<template>  
    <div v-if="loading" class="loading">Loading...</div>    
</template>

<script>

export default {
    name: "Logout",        
    created() {
        this.$store.dispatch('Logout', true);
        window.location.replace("/#/")
    }
};
</script>